// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_m9-0";